var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 147.529 143.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4389.21 226.951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.692,30.317h0L304.7,16.644a31.277,31.277,0,0,0-24.874-5.258,46.179,46.179,0,0,0-14.448,5.466h0L316.17,53.4c12.3,8.937,16.071,25.321,16.071,25.321l3.65-11.171h0A33.26,33.26,0,0,0,323.692,30.317Z",
    transform: "translate(4199.227 -221.717)",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.7,40.86l-19.362,59.4c-4.781,14.433-19.289,23.131-19.289,23.131h11.841a33.511,33.511,0,0,0,31.874-23.131l7.18-22.059a31.275,31.275,0,0,0-2.667-25.5A45.264,45.264,0,0,0,311.7,40.86Z",
    transform: "translate(4202.983 -206.954)",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.02,84.435H251.687C236.48,84.435,223.7,73.19,223.7,73.19l3.664,11.245a33.5,33.5,0,0,0,31.859,23.131H282.4A31.383,31.383,0,0,0,306.23,96.679a43.949,43.949,0,0,0,7.789-12.243Z",
    transform: "translate(4178.827 -191.13)",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.332,108.454,236.074,49.427c-4.707-14.448,1.966-30.117,1.966-30.117L228.522,26.3a33.647,33.647,0,0,0-12.109,37.549h0l7.045,21.642a31.277,31.277,0,0,0,17.1,19.005A45.3,45.3,0,0,0,255.332,108.454Z",
    transform: "translate(4174.449 -217.502)",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.54,6.315a33.513,33.513,0,0,0-39.381.164h0l-18.5,13.554a31.5,31.5,0,0,0-12.779,22.774,44.671,44.671,0,0,0,.878,14.626l50.15-36.745c12.317-8.937,29.178-7.447,29.178-7.447Z",
    transform: "translate(4181.732 -226.952)",
    fill: "currentcolor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.b860dddf894382ddeae354edab527559.svg";
export { ForwardRef as ReactComponent };